import React from 'react';
import styled from 'styled-components';

const MenuItemContainer = styled.button`
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  min-height: 55px;
  padding: ${({ theme }) => theme.spacingBase};
  width: 100%;
  cursor: pointer;
  border: 0;
`;

const MenuItemSide = styled.aside`
  flex: 0 1 75px;
`;

const MenuItemContent = styled.div`
  flex: 1 1 100%;
  text-align: left;
  padding-left: ${({ theme }) => theme.spacingDouble};
  padding-right: ${({ theme }) => theme.spacingBase};
`;

export default function MenuItem({ children, ...props }) {
  const numChildren = React.Children.count(children);
  let renderableElements = null;
  if (numChildren >= 3) {
    renderableElements = (
      <>
        <MenuItemSide>{children[0]}</MenuItemSide>
        <MenuItemContent>{children.slice(1, -1)}</MenuItemContent>
        <MenuItemSide>{children[numChildren - 1]}</MenuItemSide>
      </>
    );
  } else {
    renderableElements = <MenuItemContent>{children}</MenuItemContent>;
  }

  return <MenuItemContainer {...props}>{renderableElements}</MenuItemContainer>;
}
